import { Form as FormAD, type FormInstance, type FormProps } from 'antd';
import type React from 'react';

type FormP<Values = any> = FormProps<Values> & {
  children?: React.ReactNode;
} & {
  ref?: React.Ref<FormInstance<Values>> | undefined;
};

function Form<Values = any>(props: FormP<Values>) {
  return <FormAD<Values> layout="vertical" {...props} scrollToFirstError={{ behavior: 'smooth', block: 'center' }} />;
}

Form.useForm = FormAD.useForm;
Form.List = FormAD.List;
Form.Item = FormAD.Item;

export { type Rule, type FormInstance, type FormListFieldData } from 'antd/lib/form';
export default Form;
